import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import cx from 'classnames';

import style from './style';

import Google from '../providers/google';
import SemShopping from '../providers/semshopping';
import Sem from '../providers/sem';
import { withConfig } from '../../config';

import { Select, Option } from '@cube/blocks';

@withConfig([
	'search.dropdownProviders'
])
export default class DropDownSearch extends Component {

	state = {
		selectedProvider: Google
	};

	onChange = ({ value }) => {
		this.setState({ activeProvider: value });
	};

	getProvider = (name) => {
		if (name === 'google') return Google;
		if (name === 'semshopping') return SemShopping;
		if (name === 'sem') return Sem;
	};

	getInputPeers = (dropdownProviders, activeProvider) => {
		if (dropdownProviders.length === 1) return;

		return (
			<Select anchor="right" value={activeProvider} onChange={this.onChange} class={style.wrapper} buttonClass={style.button} >
				{
					dropdownProviders.map((provider) => (
						<Option value={provider} title={<Text id={`dropdownLabels.${provider}`} />} />
					))
				}
			</Select>
		);
	};

	componentWillMount() {
		if (!this.props.dropdownProviders || this.props.dropdownProviders.length === 0) return;
		this.setState({
			activeProvider: this.props.defaultProvider || this.props.dropdownProviders[0]
		});
	}

	render({ dropdownProviders, ...props }, { activeProvider }) {
		// If no dropdownProviders defined there there is a problem, do not show search
		if (!dropdownProviders || dropdownProviders.length === 0) return;

		let Provider = this.getProvider(activeProvider),
			inputPeers = this.getInputPeers(dropdownProviders, activeProvider);

		return (
			<Provider
				{...props}
				inputPeers={inputPeers}
				inputTextClass={cx(style.inputText, props.inputTextClass)}
			/>
		);
	}
}
